<template>
  <div class="step-header row mb-4">
    <div class="col-12 d-flex">
      <div class="step-header-step text-white text-center" :style="{ backgroundColor: color }">
        <span class="font-montserrat">{{ step }}</span>
      </div>
      <div class="step-header-text ml-4">
        <h3 class="font-patrick-hand mb-1">{{ subTitle }}</h3>
        <h1>{{ title }}</h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepHeader',
  props: {
    step: Number,
    total: Number,
    title: String,
    subTitle: String,
    themeColor: {
      type: String,
      default: 'rgb(255,96,8)'
    }
  },
  computed: {
    color () {
      let alphaColor = this.themeColor.replace('rgba', 'rgb')
      return alphaColor.replace(')', `, ${(this.step + 1) / (this.total + 1)})`)
    }
  }
}
</script>
